export namespace Constants.Enums {
  export const ACTIVATION_STATUS = {
    AWAITING_ACTIVATION: 0,
    ACTIVE: 1,
    DEACTIVATED: 2,
  };

  export const BUSINESSUNITSTATUS = {
    INACTIVE: 0,
    PENDING_ACTIVATE: 1,
    ACTIVE: 2,
    PENDING_PAYMENT: 3,
  };

  export const BUSINESSUNIT_ACTIVATION_REQUEST_STATUS = {
    REQUESTED: 0,
    APPROVED: 1,
    REPPROVED: 2,
  };

  export const BUSINESS_UNIT_JOIN_REQUEST_STATUS = {
    REQUESTED: 0,
    APPROVED: 1,
    DENIED: 2,
    CANCELLED: 3,
  };

  export const BUSINESSUNITTYPE = {
    SHOPKEEPER: 0,
    DISTRIBUTOR: 1,
    INDUSTRY: 2,
  };

  export const ACCOUNT_TYPE = {
    PLATFORM: 0,
    PROFESSIONALS_PAYMENTS: 1,
  };

  export const BUSINESSUNIT_MEMBERSHIP_PLAN_STATUS = {
    INACTIVE: 0,
    PENDING_ACTIVATE: 1,
    ACTIVE: 2,
    PENDING_PAYMENT: 3,
  };

  export const APPLICATIONSTATUS = {
    InManteinance: 0,
    Running: 1,
  };

  export const PROFILE_TYPE = {
    UNDEFINED: 0,
    ADMINISTRATIVE_USER: 1,
    GROOMER: 2,
    BUSINESS_UNIT: 3,
  };

  export const ACCESS_SOURCE = {
    PORTAL: 0,
    APP: 1,
  };

  export const ACCESS_SOURCE_OPTIONS = [
    { value: "", text: "Todas as origens" },
    { value: "0", text: "Portal" },
    { value: "1", text: "Aplicativo" },
  ];

  export const ACCESS_STATUS = {
    ACTIVE: 0,
    CLOSED: 1,
  };

  export const ACCESS_STATUS_OPTIONS = [
    { value: "", text: "Todos os status" },
    { value: "0", text: "Ativo" },
    { value: "1", text: "Encerrado" },
  ];

  export const ACCESS_PROFILE_TYPE_OPTIONS = [
    { value: "", text: "Todos os tipos" },
    { value: "1", text: "Administrativo" },
    { value: "2", text: "Profissional" },
    { value: "3", text: "Lojista" },
  ];

  export const PROFILE_TYPE_TITLES = [
    { value: 0, description: "Indefinido" },
    { value: 1, description: "Usuário Administrativo" },
    { value: 2, description: "Profissional" },
    { value: 3, description: "Empresa" },
  ];

  export const FEE_TYPE = {
    ADMINISTRATIVE_FEE: 0,
    HIRING_FEE: 1,
    FAST_HIRING_FEE: 2,
    OPPORTUNITY_BOOST_FEE: 3,
    PROFILE_BOOST_FEE: 4,
    POST_BOOT_FEE: 5,
    FINE_FOR_ABSENCE: 6,
  };

  export const FEE_TYPE_TITLE = [
    { value: 0, description: "Taxa de Serviço" },
    { value: 1, description: "Taxa de Contratação Convencional" },
    { value: 2, description: "Taxa de Contratação Rápida" },
    { value: 3, description: "Taxa de Impulsionamento de Vagas" },
    { value: 4, description: "Taxa de Impulsionamento de Perfil" },
    { value: 5, description: "Taxa de Impulsionamento de Publicações" },
    { value: 6, description: "Multa por Falta (Aplicado apenas à profissionais)" },
  ];

  export const CHARGE_TYPE = {
    FIXEDVALUE: 0,
    PERCENTVALUE: 1,
  };

  export const CHARGE_TYPE_TITLE = [
    { value: 0, description: "Valor Fixo" },
    { value: 1, description: "Percentual" },
  ];

  export const SPLIT_PARTICIPANT_TYPE = {
    BUSINESS_UNIT: 0,
    PROFESSIONAL: 1,
    PLATFORM: 2,
  };

  export const PROFESSION_LEVELS = [
    { id: 0, description: "Júnior" },
    { id: 1, description: "Pleno" },
    { id: 2, description: "Sênior" },
    { id: 3, description: "Especialista" },
  ];

  export const PIX_ADDRESS_KEY_TYPE_TITLES = [
    { value: "CPF", description: "CPF" },
    { value: "CNPJ", description: "CNPJ" },
    { value: "EMAIL", description: "Email" },
    { value: "PHONE", description: "Telefone" },
    { value: "EVP", description: "Aleatória" },
  ];

  export const PIX_ADDRESS_KEY_TYPE = {
    CPF: "CPF",
    CNPJ: "CNPJ",
    EMAIL: "EMAIL",
    PHONE: "PHONE",
    EVP: "EVP",
  };

  export const OPPORTUNITY_STATUS_TITLE = [
    { id: 0, description: "Pausada" },
    { id: 1, description: "Ativa" },
    { id: 2, description: "Expirada" },
    { id: 3, description: "Encerrada" },
  ];

  export const OPPORTUNITY_STATUS = {
    PAUSED: 0,
    RELEASED: 1,
    EXPIRED: 2,
    CLOSED: 3,
  };

  export const HIRING_STATUS_TITLE = [
    { id: 0, description: "Ativa" },
    { id: 1, description: "Encerrada" },
    { id: 2, description: "Cancelada" },
    { id: 3, description: "Cancelada por Falta" },
  ];

  export const HIRING_STATUS = {
    OPEN: 0,
    CLOSED: 1,
    CANCELED: 2,
    CANCELED_FOR_ABSENCE: 3,
  };

  export const EVALUATION_STATUS = {
    PENDING: 0,
    MADE: 1,
  };

  export const INVITE_STATUS = {
    AWAITING_RESPONSE: 0,
    ACCEPTED: 1,
    DENIED: 2,
    EXPIRED: 3,
    HIRED: 4,
    NOT_HIRED: 5,
    AWAITING_HIRING_RESPONSE: 6,
  };

  /** Fallback do limite de convites por vaga; preferir opportunity.maxInvitesPerOpportunity da API. */
  export const MAX_INVITES_PER_OPPORTUNITY: number = 5;

  /** Convite ainda ocupa 1 vaga da cota (recusa/expiração libera 1). */
  export function inviteOccupiesQuota(status: number, expiresAt?: string | null): boolean {
    const occupying =
      status === INVITE_STATUS.AWAITING_RESPONSE ||
      status === INVITE_STATUS.ACCEPTED ||
      status === INVITE_STATUS.HIRED ||
      status === INVITE_STATUS.AWAITING_HIRING_RESPONSE;
    if (!occupying) return false;
    if (
      status === INVITE_STATUS.AWAITING_RESPONSE &&
      expiresAt
    ) {
      const deadline = new Date(expiresAt).getTime();
      if (Number.isFinite(deadline) && deadline <= Date.now()) return false;
    }
    return true;
  }

  export const INVITE_STATUS_TITLE = [
    { id: 0, description: "Aguardando resposta" },
    { id: 1, description: "Aceito — aguardando contratação da empresa" },
    { id: 2, description: "Este convite foi recusado" },
    { id: 3, description: "Convite Expirado" },
    { id: 4, description: "Contratado" },
    { id: 5, description: "A empresa contratou outro profissional" },
    { id: 6, description: "Aguardando resposta" },
  ];

  export const PERSONTYPE = {
    ADMINISTRATIVE_USER: 0,
    USER: 1,
    BUSINESS_UNIT: 2,
    NO_USER: 3,
  };

  export const SHARE_TYPE = {
    BUSINESSUNIT: 0,
    GROUP: 1,
    PROFILE: 2,
    PRODUCT: 3,
    SERVICE: 4,
    POST: 5,
  };

  export const ADM_USER_PAYMENT = [3];

  export const CREDENTIALTYPE = {
    EMail: 0,
    Document: 1,
    NickName: 2,
  };

  export const DOCUMENTTYPE = {
    CPF: 0,
    RG: 1,
    CNPJ: 2,
  };

  export const CONTACTTYPE = {
    MOBILE: 0,
    LANDLINE: 1,
    MAILADDRESS: 2,
    WHATSAPP: 3,
  };

  export const DOCUMENTS = [
    { value: 1, description: "CPF" },
    { value: 2, description: "RG" },
    { value: 3, description: "CNPJ" },
    { value: 4, description: "IE" },
  ];

  export const CONTACTS = [
    { value: 1, description: "Celular" },
    { value: 2, description: "Telefone Fixo" },
    { value: 3, description: "E-Mail" },
    { value: 4, description: "Whatsapp" },
  ];

  export const MARITALSTATUS = {
    Single: 0,
    Married: 1,
    Divorced: 2,
    Widower: 3,
    Loving: 4,
  };

  export const GENRE = [
    { value: 0, description: "Masculino" },
    { value: 1, description: "Feminino" },
    { value: 2, description: "Prefiro não informar" },
  ];

  export const OfferType = [
    { value: 1, description: "Produtos" },
    { value: 2, description: "Serviços" },
    { value: 3, description: "Ambos" },
  ];

  export const BUSINESS_UNIT_PERSON_TYPE = [
    { value: 1, description: "Sócio/Fundador" },
    { value: 2, description: "Sócio" },
    { value: 3, description: "Colaborador" },
  ];

  export const BUSINESSUNIT_PERSONTYPE = {
    OWNER: 1,
    PARTNER: 2,
    EMPOYEE: 3,
  };

  export const BUSINESSUNIT_PROFILE_OPTIONS = {
    ANALYTICS: 0,
    DESIGN: 1,
    PRINCIPAL_DATA: 2,
    ABOUT_HISTORY: 3,
    PRODUCT_MIX: 4,
    INSERTS: 5,
    REPRESENTATIVES: 6,
    ORDERS: 7,
    SERVICE_MIX: 8,
    ATENDANTS: 9,
    SCHEDULE: 10,
    ADOPET: 11,
    MARKETING_ACTIONS: 12,
    ADMINISTRATIVE_USERS: 13,
    PARAMETERS_CONFIG: 14,
    BANKING_DATA: 15,
    DELIVERY_CONFIG: 16,
    MEMBERSHIP_PLANS: 17,
  };

  export const BUSINESSUNIT_PROFILE_OPTIONS_TITLES = [
    { id: 0, description: "Analytics" },
    { id: 1, description: "Design" },
    { id: 2, description: "Dados Principais" },
    { id: 3, description: "Sobre" },
    { id: 4, description: "Mix de Produtos" },
    { id: 5, description: "Inserções" },
    { id: 6, description: "Representantes" },
    { id: 7, description: "Meus Pedidos" },
    { id: 8, description: "Mix de Serviços" },
    { id: 9, description: "Atendentes" },
    { id: 10, description: "Agenda" },
    { id: 11, description: "AdoPet" },
    { id: 12, description: "Ações de Marketing" },
    { id: 13, description: "Usuários" },
    { id: 14, description: "Parâmetros de Operação" },
    { id: 15, description: "Dados Bancários" },
    { id: 16, description: "Delivery" },
    { id: 17, description: "Planos de Adesão" },
  ];

  export const PRODUCTOFFERTYPE = {
    PRODUCT: 1,
    SERVICE: 2,
    BOTH: 3,
  };

  export const CITIES = [
    { id: 1, description: "RO" },
    { id: 2, description: "AC" },
    { id: 3, description: "AM" },
    { id: 4, description: "RR" },
    { id: 5, description: "PA" },
    { id: 6, description: "AP" },
    { id: 7, description: "TO" },
    { id: 8, description: "MA" },
    { id: 9, description: "PI" },
    { id: 10, description: "CE" },
    { id: 11, description: "RN" },
    { id: 12, description: "PB" },
    { id: 13, description: "PE" },
    { id: 14, description: "AL" },
    { id: 15, description: "SE" },
    { id: 16, description: "BA" },
    { id: 17, description: "MG" },
    { id: 18, description: "ES" },
    { id: 19, description: "RJ" },
    { id: 20, description: "SP" },
    { id: 21, description: "PR" },
    { id: 22, description: "SC" },
    { id: 23, description: "RS" },
    { id: 24, description: "MS" },
    { id: 25, description: "MT" },
    { id: 26, description: "GO" },
    { id: 27, description: "DF" },
  ];

  export const COUNTRIES = [{ id: 1, description: "BRASIL" }];

  export const SEARCHRESPONSE = {
    TYPE: {
      USER: 0,
      PERSON: 1,
    },
  };

  export const NOTIFICATIONTYPE = {
    NONE: 0,
    INTERNAL: 1,
    EMAIL: 2,
    SMS: 3,
    WHATSAPP: 4,
    PUSH: 5,
    ALL: 6,
  };

  export const PETTYPE = [
    { value: -1, description: "" },
    { value: 0, description: "Cachorro" },
    { value: 1, description: "Gato" },
    { value: 2, description: "Pássaro" },
    { value: 3, description: "Hamster" },
    { value: 4, description: "Tartaruga" },
  ];

  export const PET_GENRE = [
    { value: -1, description: "" },
    { value: 0, description: "Macho" },
    { value: 1, description: "Fêmea" },
  ];
  export const PET_SIZE = [
    { value: -1, description: "" },
    { value: 0, description: "Pequeno" },
    { value: 1, description: "Médio" },
    { value: 2, description: "Grande" },
  ];

  export const CASTRATED = [
    { value: false, description: "Não" },
    { value: true, description: "Sim" },
  ];

  export const IMAGETYPE = {
    TYPE: {
      PRODUCT: 0,
      BUSINESSUNITLOGO: 1,
      PET: 2,
      PROFILE: 3,
      GROUP: 4,
      PUBLICATION: 5,
      PHOTOALBUM: 6,
      SERVICE: 7,
      DEFAULT: 8,
      EVALUATION: 9,
      HEADERSTORE: 10,
    },
  };

  export const IMAGETRANSACTIONTYPE = {
    TYPE: {
      UPDATE: 0,
      SELECTONLY: 1,
    },
  };

  export const GROUPPERSONTYPE = {
    TYPE: {
      OWNER: 0,
      ADMINISTRATIVEMEMBER: 1,
      MEMBER: 2,
    },
  };

  export const EXPOSURELEVELLIST = {
    LEVEL: {
      PUBLIC: 0,
      PRIVATE: 1,
    },
  };

  export const EXPOSURELEVEL = [
    { value: 0, description: "Público" },
    { value: 1, description: "Particular" },
  ];

  export const POST = {
    TYPE: {
      PHOTO: 0,
      VIDEO: 1,
      EVENT: 2,
      ARTICLE: 3,
    },
  };

  export const REACTION = {
    TYPE: {
      LIKE: 0,
      LOVE: 1,
      CONGRATS: 2,
      SMILE: 3,
      SAD: 4,
      HATE: 5,
    },
  };

  export const CATEGORIES = {
    LEVEL: {
      CATEGORIE: 0,
      SUBCATEGORIE_LEVEL1: 1,
      SUBCATEGORIE_LEVEL2: 2,
      SUBCATEGORIE_LEVEL3: 3,
    },
  };

  export const PRODUCTLISTTYPEOPTIONS = [
    { value: 0, description: "Genérico" },
    { value: 1, description: "Fazem sucesso entre os pets" },
    { value: 2, description: "Baseado nas suas últimas pesquisas" },
    { value: 3, description: "Achamos que podem te interessar" },
  ];

  export const PRODUCTLISTTYPE = {
    SEVERAL: 0,
    FEATURED: 1,
    SEARCHED: 2,
    SUGGESTION: 3,
  };

  export const SEARCHTYPE = {
    PRODUCT: 0,
    SERVICE: 1,
    SHOPKEEPER_PRODUCT: 2,
    USER: 3,
    GROUP: 4,
    SHOPKEEPER: 5,
    PRODUCTS_BY_CATEGORY: 6,
  };

  export const PARAMETERS_TYPES_VALUES = [
    { value: 0, description: "Selecione um tipo de parâmetro" },
    { value: 1, description: "Texto simples" },
    { value: 2, description: "Verdadeiro - Falso" },
    { value: 3, description: "Lista de Opções" },
    { value: 4, description: "De - Até" },
  ];

  export const PARAMETERS_TYPES = {
    SIMPLE_TEXT: 1,
    TRUE_OR_FALSE: 2,
    OPTIONS_LIST: 3,
    FROM_TO: 4,
  };

  export const MULTIPLE_OPTIONS = [
    { value: false, description: "Não" },
    { value: true, description: "Sim" },
  ];

  export const PARAMETER_INTERNAL_CODE = [
    { value: 0, description: "Selecione o código interno do parâmetro" },
    { value: 1, description: "Company_Slogan" },
    { value: 2, description: "Delivery_System" },
    { value: 3, description: "Week_Days" },
    { value: 4, description: "Week_Days_Opening_Hours" },
    { value: 5, description: "Weekend_Days" },
    { value: 6, description: "Saturday_Opening_Hours" },
    { value: 7, description: "Sunday_Opening_Hours" },
    { value: 8, description: "Delivery_Distance" },
    { value: 9, description: "Allow_Service_Scheduling" },
  ];

  export const PARAMETER_INTERNAL_CODE_VALUE = {
    COMPANY_SLOGAN: 1,
    DELIVERY_SYSTEM: 2,
    WEEK_DAYS: 3,
    WEEK_DAYS_OPENING_HOURS: 4,
    WEEKEND_DAYS: 5,
    SATURDAY_OPENING_HOURS: 6,
    SUNDAY_OPENING_HOURS: 7,
    DELIVERY_DISTANCE: 8,
    ALLOW_SERVICE_SCHEDULING: 9,
  };

  export const PARAMETER_VALUE_TYPE = [
    { value: 0, description: "Selecione o tipo de valores do parâmetro" },
    { value: 1, description: "Números" },
    { value: 2, description: "Horas" },
  ];

  export const NAVIGATION_TYPE = {
    USER: 0,
    COMPANY: 1,
    ANONYMOUS: 2,
  };

  export const VISUALIZATION_TYPES = {
    LIST: 0,
    MAP: 1,
  };

  export const CONTACT_SUBJECT = [
    { id: 1, description: "Tenho uma sugestão" },
    { id: 2, description: "Tenho um elogio" },
    { id: 3, description: "Tenho um problema" },
  ];

  export const TYPEUSER = {
    TEAM_BU: 0,
    USER: 1,
  };

  export const ORDER_STATUS = [
    { value: 0, description: "Aguardando Emissão", color: "orange" },
    { value: 1, description: "Aguardando Confirmação", color: "orange" },
    { value: 2, description: "Confirmado", color: "green" },
    { value: 3, description: "Negado", color: "red" },
    { value: 4, description: "À Caminho", color: "green" },
    { value: 5, description: "Entregue", color: "green" },
    { value: 6, description: "Cancelado", color: "red" },
  ];

  export const ORDERSTATUS = {
    CREATED: 0,
    ISSUED: 1,
    CONFIRMED: 2,
    DISAPPROVED: 3,
    ONWAY: 4,
    DELIVERED: 5,
    CANCELED: 6,
  };

  export const PRODUCTSUGESTIONSTATUS = {
    Created: 0,
    RegistrationProcess: 1,
    Rejected: 2,
    Registered: 3,
  };

  export const PRODUCTSUGESTIONSTATUS_DESCRIPTION = [
    { value: 0, description: "Cadastro Pendente" },
    { value: 1, description: "Cadastro em Andamento" },
    { value: 2, description: "Cadastro não Efetuado" },
    { value: 3, description: "Cadastro Efetuado" },
  ];

  export const BUSINESSUNIT_INTERACTION_TYPE = {
    BUSINESSUNITACCESS: 0,
    BUSINESSUNITCONTACT: 1,
    BUSINESSUNITLINKSHARE: 2,
    PRODUCTACCESS: 3,
    SERVICEACCESS: 4,
    ADOPETACCESS: 5,
    CONTENTVISUALIZATION: 6,
    SHOPCARTPRODUCTADDED: 7,
    PRODUCTBUY: 8,
    SERVICESCHEDULE: 9,
    ADOPETINTEREST: 10,
    CONTENTSHARE: 11,
    ADOPETCONFIRMED: 12,
    ALL: 99,
  };

  export const BUSINESSUNIT_INTERACTION_TYPE_DESCRIPTION = [
    { value: 0, description: "Acesso à Loja" },
    { value: 1, description: "Falou com a empresa" },
    { value: 2, description: "Compartilhou o endereço da empresa" },
    { value: 3, description: "Acessou um produto da empresa" },
    { value: 4, description: "Acessou um serviço da empresa" },
    { value: 5, description: "Acessou um animal da empresa" },
    { value: 6, description: "Visualizou um conteúdo postado" },
    {
      value: 7,
      description: "Adicionou um produto da empresa no carrinho de compras",
    },
    { value: 8, description: "Comprou um produto da empresa" },
    { value: 9, description: "Agendou/Solicitou um serviço" },
    { value: 10, description: "Se interessou por um animal da empresa" },
    { value: 11, description: "Compartilhou um conteúdo da empresa" },
    { description: "", value: 99 },
  ];

  export const TIMELINE_TYPE = {
    SUGESTIONS: 0,
    FOLLOWED: 1,
    USER: 2,
    GROUP: 3,
    PUBLIC_USER: 4,
  };

  export const MEMBERSHIP_PLAN = {
    SHOPKEEPER: 1,
    PROVIDER: 2,
    ADOPET: 3,
  };

  export const MARKETPET_TABS = {
    PRODUCTS: 0,
    SERVICES: 1,
    ADOPET: 2,
  };

  export const REPRESENTATION_RELATIONSHIP_STATUS = {
    ACTIVE: 0,
    INACTIVE: 1,
  };

  export const BUSINESSUNIT_DISTRIBUTOR_PRODUCTBRAND_RELATIONSHIP_STATUS = {
    ACTIVE: 0,
    INACTIVE: 1,
  };

  export const SUPPORT_STATUS = {
    REQUIRED: 0,
    IN_PROGRESS: 1,
    CLOSED: 2,
  };

  export const SUPPORT_STATUS_TITLES = [
    { id: 0, description: "Aguardando Atendimento" },
    { id: 1, description: "Em Atendimento" },
    { id: 2, description: "Atendimento Concluído" },
  ];

  export const PAYMENT_SCHEDULE_STATUS = {
    SCHEDULED: 0,
    PAYD: 1,
    CANCELED: 2,
  };

  export const PAYMENT_SCHEDULE_STATUS_TITLES = [
    { id: 0, description: "Pendente" },
    { id: 1, description: "Pagamento Efetuado" },
    { id: 2, description: "Pagamento Cancelado" },
  ];

  export const USER_ACTIVATION_STATUS = [
    { id: 0, description: "Aguardando Ativação" },
    { id: 1, description: "Ativo" },
    { id: 2, description: "Desativado" },
  ];

  export const PROFESSIONALS_STATUS_FILTER_OPTIONS = [
    { value: "active", text: "Ativos" },
    { value: "awaiting", text: "Aguardando ativação" },
    { value: "inactive", text: "Inativos" },
  ];

  /** Status 1 — Negociação / Pagamento (painel Acompanhamento de Transações) */
  export const TRANSACTION_MONITORING_STATUS1 = {
    INVITE_SENT: "InviteSent",
    INVITE_ACCEPTED: "InviteAccepted",
    PAYMENT_CONFIRMED: "PaymentConfirmed",
    NO_INVITES: "NoInvites",
  };

  export const TRANSACTION_MONITORING_STATUS1_OPTIONS = [
    { value: "", text: "Negociação (todos)" },
    { value: "InviteSent", text: "Convite enviado" },
    { value: "InviteAccepted", text: "Convite aceito" },
    { value: "PaymentConfirmed", text: "Pago à plataforma" },
    { value: "NoInvites", text: "Sem convites" },
  ];

  /** Status 2 — Execução do serviço */
  export const TRANSACTION_MONITORING_STATUS2 = {
    AWAITING: "Awaiting",
    AWAITING_PAYMENT: "AwaitingPayment",
    AWAITING_SERVICE: "AwaitingService",
    FINISHED: "Finished",
    NO_SHOW: "NoShow",
    CANCELED: "Canceled",
    PRESENCE_CONFIRMED: "PresenceConfirmed",
    CHECK_IN_MISSING: "CheckInMissing",
    AWAITING_CHECK_IN: "AwaitingCheckIn",
  };

  export const TRANSACTION_MONITORING_STATUS2_OPTIONS = [
    { value: "", text: "Execução (todos)" },
    { value: "Awaiting", text: "Aguardando" },
    { value: "AwaitingPayment", text: "Aguardando pagamento" },
    { value: "AwaitingService", text: "Aguardando serviço" },
    { value: "AwaitingCheckIn", text: "Aguardando check-in" },
    { value: "PresenceConfirmed", text: "Presença confirmada" },
    { value: "CheckInMissing", text: "Check-in não realizado" },
    { value: "Finished", text: "Avaliações concluídas" },
    { value: "NoShow", text: "Não compareceu" },
    { value: "Canceled", text: "Cancelado" },
  ];
}
